import { createContext } from "react";

import { IMessageContext } from "../types";

export const MessageContext = createContext<IMessageContext | null>(null);
